import React, { useEffect, useState } from "react";

import moment from "moment";
import { OrderProps } from "../../types/order";

type Props = {
  order: OrderProps;
};

const OrderPdf = ({ order }: Props) => {
  const companyName = process.env.REACT_APP_COMPANY_NAME;
  const [isIos, setIsIos] = useState(false);

  useEffect(() => {
    const platform = window.navigator.platform;
    setIsIos(/Mac|iPod|iPhone|iPad/.test(platform) ? true : false);
  }, []);

  return (
    <div
      style={{
        position: "relative",
        display: "grid",
        height: isIos ? "598px" : "148mm",
        width: "105mm",
        padding: isIos ? "0px 10px" : "5px 20px 20px 20px",
        overflow: "hidden",
      }}
    >
      <h1 className="text-2xl font-bold text-black text-center">
        {companyName}
      </h1>
      <div className="flex justify-between mt-2">
        <div className="grid gap-2">
          <p className="text-base text-black font-semibold">
            <span className="font-bold mr-5">Party </span>:{" "}
            {order.party.firm_name}
          </p>
          <p className="text-base text-black font-semibold">
            <span className="font-bold mr-[5px]">Date </span>:{" "}
            {order?.created_at
              ? moment(order?.created_at, "YYYY-MM-DD HH:mm:ss").format(
                  "DD-MM-YYYY"
                )
              : ""}
          </p>
          <p className="text-base text-black font-semibold">
            <span className="font-bold mr-4">Time </span>:{" "}
            {order?.created_at
              ? moment(order?.created_at, "YYYY-MM-DD HH:mm:ss").format(
                  "hh:mm A"
                )
              : ""}
          </p>
        </div>
        <p className="text-base text-black font-semibold">
          <span className="font-bold">Order ID </span>: {order?.id}
        </p>
      </div>
      <div className="w-full h-[200px] p-5 -mt-3"></div>
      <table className="w-full border-collapse -mt-3">
        <tbody>
          <tr>
            <td className="text-base text-black px-[6px] py-1 font-bold w-[90px] border border-black">
              Item :
            </td>
            <td className="text-base text-black px-[6px] py-1 font-semibold border border-black">
              {order?.item?.name || ""}
            </td>
          </tr>
          <tr>
            <td className="text-base text-black px-[6px] py-1 font-bold w-[90px] border border-black">
              Process :
            </td>
            <td className="text-base text-black px-[6px] py-1 font-semibold border border-black">
              {order?.process?.name || ""}
            </td>
          </tr>
          <tr>
            <td className="text-base text-black px-[6px] py-1 font-bold w-[90px] border border-black">
              Unit :
            </td>
            <td className="text-base text-black px-[6px] py-1 font-semibold border border-black">
              {order?.unit?.name || ""}
            </td>
          </tr>
          <tr>
            <td className="text-base text-black px-[6px] py-1 font-bold w-[90px] border border-black">
              Rate :
            </td>
            <td className="text-base text-black px-[6px] py-1 font-semibold border border-black">
              {order?.rate || ""}
            </td>
          </tr>
          <tr>
            <td className="text-base text-black px-[6px] py-1 font-bold w-[90px] border border-black">
              Quantity :
            </td>
            <td className="text-base text-black px-[6px] py-1 font-semibold border border-black">
              {order?.qty || ""}
            </td>
          </tr>
        </tbody>
      </table>
      <div style={{ pageBreakAfter: "always", breakAfter: "page" }}></div>
    </div>
  );
};
export default OrderPdf;
